import React, { Component } from 'react'
import Helmet from 'react-helmet'
import { FormattedMessage } from 'react-intl'
import animateScrollTo from 'animated-scroll-to'

import { HashRouter, Switch, Route, Link, withRouter } from 'react-router-dom'

import DownshiftCheckbox from '../components/downshift-checkbox'
import arrowIcon from '../images/svg/arrow-right.svg'
import plusBlack from '../images/svg/plus-black.svg'
import Map from '../components/map'
import Slideshow from '../components/slideshow'
import './mappe.sass'
import slug from 'slug'

class MappePage extends Component {
  state = {
    selectedItem: null,
    puntiMappa: [],
    filteredPuntiMappa: [],
    tipologie: [],
    selectedTipologie: [],
    autori: [],
    selectedAutori: [],
    luoghi: [],
    selectedLuoghi: [],
    periodi: [],
    selectedPeriodi: [],
  }

  componentDidMount() {
    let locale = 'it'

    if (typeof window !== 'undefined') {
      locale = window.localStorage.getItem('locale')
    }

    // Filtro le opere per locale
    const opereThisLocale = this.props.data.allDatoCmsPuntiSullaMappa.edges
      .map(opera => ({ ...opera.node, slug: slug(opera.node.nome) }))
      .filter(opera => {
        return (
          opera.locale === locale &&
          opera.nome.toLowerCase().indexOf('non toccare') < 0 &&
          opera.nome.toLowerCase().indexOf('do not touch') < 0
        )
      })

    this.setState({
      puntiMappa: opereThisLocale,
      filteredPuntiMappa: [],
      tipologie: this.props.data.tipologieOpera.edges
        .map(edge => edge.node)
        .filter(tipologia => tipologia.locale === locale),
      autori: this.props.data.autori.edges
        .map(edge => edge.node)
        .filter(autore => autore.locale === locale),
      luoghi: this.props.data.luoghi.edges
        .map(edge => edge.node)
        .filter(autore => autore.locale === locale),
      periodi: this.props.data.periodi.edges
        .map(edge => edge.node)
        .filter(autore => autore.locale === locale),
    })

    const { location } = this.props

    if (location.hash) {
      const selectedItem = opereThisLocale.find(
        o => location.hash.substr(2) === o.slug
      )

      if (selectedItem) {
        this.setState({ selectedItem })
      }
    }
  }

  filtraListaOpere = () => {
    let filteredPuntiMappa = []

    // Nessun filtro, mostro la lista intera
    if (
      this.state.selectedTipologie.length === 0 &&
      this.state.selectedAutori.length === 0 &&
      this.state.selectedLuoghi.length === 0 &&
      this.state.selectedPeriodi.length === 0
    ) {
      return this.setState({ filteredPuntiMappa })
    }

    // Tipologie

    if (this.state.selectedTipologie.length > 0) {
      filteredPuntiMappa = this.state.puntiMappa.filter(opera => {
        return (
          this.state.selectedTipologie
            .map(tipologia => tipologia.nomeDellaTipologia)
            .indexOf(opera.tipologiaOpera.nomeDellaTipologia) >= 0
        )
      })
    } else {
      filteredPuntiMappa = this.state.puntiMappa
    }

    // Autori

    if (this.state.selectedAutori.length > 0) {
      filteredPuntiMappa = filteredPuntiMappa.filter(opera => {
        const selectedAutori = this.state.selectedAutori.map(
          autore => autore.nome
        )

        let selectedAutoreFound = false

        const autoriOpera = opera.autore.reduce(
          (autori, autore) => `${autori} ${autore.nome}`,
          ''
        )

        selectedAutori.forEach(autore => {
          if (autoriOpera.indexOf(autore) >= 0) {
            selectedAutoreFound = true
          }
        })

        return selectedAutoreFound
      })
    }

    // Luoghi

    if (this.state.selectedLuoghi.length > 0) {
      filteredPuntiMappa = filteredPuntiMappa.filter(opera => {
        const selectedLuoghi = this.state.selectedLuoghi.map(
          luogo => luogo.nome
        )

        return selectedLuoghi.indexOf(opera.luogo.nome) >= 0
      })
    }

    // Periodi

    if (this.state.selectedPeriodi.length > 0) {
      filteredPuntiMappa = filteredPuntiMappa.filter(opera => {
        const selectedPeriodi = this.state.selectedPeriodi.map(
          periodo => periodo.nome
        )

        return selectedPeriodi.indexOf(opera.periodo.nome) >= 0
      })
    }

    this.setState({ filteredPuntiMappa })
  }

  handleListItemClick = item => {
    this.setState({ selectedItem: item })
    animateScrollTo(document.querySelector('#map'), { offset: -70 })
  }

  handleMarkerClick = () => {
    this.setState({ selectedItem: null })
  }

  handleCloseOpera = () => {
    this.setState({ selectedItem: null })
  }

  render() {
    const content = (
      <div className="wrap-narrower">
        <Helmet>
          <title>Guida | L'architettura nel Cantone Ticino, 1945 - 1980</title>
        </Helmet>

        <h1 className="text-primary mb-3">
          <FormattedMessage id="menu.mappe" />
        </h1>

        <div id="map" style={{ height: '450px' }}>
          {!this.state.selectedItem && (
            <Map
              isMarkerShown
              googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDmwnTN92pNuGaJS8uEsuOLj6JxtPIT6pw&v=3.exp&libraries=geometry,drawing,places"
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div style={{ height: `400px` }} />}
              mapElement={<div style={{ height: `100%` }} />}
              punti={this.state.filteredPuntiMappa}
              selectedItem={this.state.selectedItem}
              onMarkerClick={this.handleMarkerClick}
            />
          )}

          {this.state.selectedItem && (
            <div
              style={{
                backgroundImage: `url(${
                  this.state.selectedItem.immagineAssociata.url
                })`,
                height: '100%',
                width: '100%',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          )}
        </div>

        <div className="Mappe__Columns">
          {!this.state.selectedItem && (
            <div className="Mappe__Punti">
              {this.state.filteredPuntiMappa.length === 0 && (
                <div
                  className="Mappe__Intro text-size-1-2"
                  dangerouslySetInnerHTML={{
                    __html: this.props.data.datoCmsPaginaGuida
                      .testoIntroduttivo,
                  }}
                />
              )}

              {this.state.filteredPuntiMappa.map((item, index) => (
                <Link
                  key={index}
                  className="Collapsible"
                  to={slug(item.nome)}
                  onClick={() => this.handleListItemClick(item)}
                >
                  <div className="Collapsible__Title text-bold">
                    {item.nome}
                  </div>
                  <div className="Collapsible__PlusIconContainer">
                    <img src={arrowIcon} className="Collapsible__PlusIcon" />
                  </div>
                </Link>
              ))}
            </div>
          )}

          {this.state.selectedItem && (
            <div className="Mappe__DettaglioOpera">
              <div className="Mappe__DettaglioOpera_Nome">
                <span>{this.state.selectedItem.nome}</span>
                <Link
                  to="/"
                  onClick={this.handleCloseOpera}
                  className="Mappe__DettaglioOpera__CloseBtn"
                >
                  <img src={plusBlack} />
                </Link>
              </div>
              <div className="Mappe__DettaglioOpera__Content">
                {this.state.selectedItem.dettaglio.map(block => (
                  <div key={block.id}>
                    {block.model.apiKey === 'testo' && (
                      <div
                        className="text-size-1-2 mt-4"
                        dangerouslySetInnerHTML={{ __html: block.testo }}
                      />
                    )}

                    {block.model.apiKey === 'video' && (
                      <video
                        controls
                        src={block.video.url}
                        className="Mappe__Video mt-4"
                      />
                    )}

                    {block.model.apiKey === 'galleria_immagini' && (
                      <div className="Mappe__Slideshow__Container">
                        <div className="Mappe__Slideshow mt-4">
                          <Slideshow images={block.immagini} />
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div
            className={`Mappe__Filtri ${
              this.state.selectedItem ? 'Mappe__Filtri--hidden' : ''
            }`}
          >
            <div className="Mappe__Filtri__Content">
              {/* Tipologia */}

              <label className="Mappe__Filtri__Label">
                <FormattedMessage id="mappe.tipologia" />
              </label>
              <DownshiftCheckbox
                itemToString={item => {
                  console.log(item)
                  return item ? item.nomeDellaTipologia : ''
                }}
              >
                {({
                  getToggleButtonProps,
                  selectedItems,
                  getItemProps,
                  isOpen,
                }) => (
                  <div className="custom-select-checkbox">
                    <button
                      {...getToggleButtonProps()}
                      className={`custom-select-button ${
                        isOpen ? 'open' : ''
                      } `}
                    >
                      {selectedItems.length > 0 && (
                        <span className="Mappe__Filtri__SelectedFilters">
                          {selectedItems.reduce(
                            (acc, next, index) => `${acc}${index > 0 ? ',' : ''}
                    ${next.nomeDellaTipologia}`,
                            ''
                          )}
                        </span>
                      )}

                      {selectedItems.length === 0 && (
                        <span>
                          <FormattedMessage id="mappe.filtra" />
                        </span>
                      )}
                    </button>
                    {!isOpen ? null : (
                      <div className={`item-list ${isOpen ? 'open' : ''} `}>
                        {this.state.tipologie.map((item, index) => (
                          <label
                            className="checkbox-label custom-select-label"
                            htmlFor={item.nomeDellaTipologia}
                            key={item.nomeDellaTipologia}
                          >
                            <input
                              type="checkbox"
                              className="Mappe__Filtri__Checkbox"
                              {...getItemProps({
                                item,
                                index,
                                checked: selectedItems.includes(item),
                              })}
                              id={item.nomeDellaTipologia}
                              value={item.nomeDellaTipologia}
                              onChange={event => {
                                let newSelectedItems = selectedItems

                                if (event.target.checked) {
                                  newSelectedItems = [...selectedItems, item]
                                } else {
                                  newSelectedItems = selectedItems.filter(
                                    i =>
                                      i.nomeDellaTipologia !==
                                      item.nomeDellaTipologia
                                  )
                                }

                                this.setState(
                                  {
                                    selectedTipologie: newSelectedItems,
                                  },
                                  () => this.filtraListaOpere()
                                )
                              }}
                            />
                            <span />
                            {item.nomeDellaTipologia}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </DownshiftCheckbox>

              {/* Autore */}

              <label className="Mappe__Filtri__Label mt-1">
                <FormattedMessage id="mappe.autore" />
              </label>

              <DownshiftCheckbox
                itemToString={item => (item ? item.nome.nome : '')}
              >
                {({
                  getToggleButtonProps,
                  selectedItems,
                  getItemProps,
                  isOpen,
                }) => (
                  <div className="custom-select-checkbox">
                    <button
                      {...getToggleButtonProps()}
                      className={`custom-select-button ${
                        isOpen ? 'open' : ''
                      } `}
                    >
                      {selectedItems.length > 0 && (
                        <span className="Mappe__Filtri__SelectedFilters">
                          {selectedItems.reduce(
                            (acc, next, index) => `${acc}${index > 0 ? ',' : ''}
                    ${next.nome}`,
                            ''
                          )}
                        </span>
                      )}

                      {selectedItems.length === 0 && (
                        <span>
                          <FormattedMessage id="mappe.filtra" />
                        </span>
                      )}
                    </button>
                    {!isOpen ? null : (
                      <div className={`item-list ${isOpen ? 'open' : ''} `}>
                        {this.state.autori.map((item, index) => (
                          <label
                            className="checkbox-label custom-select-label"
                            htmlFor={item.nome}
                            key={item.nome}
                          >
                            <input
                              type="checkbox"
                              className="Mappe__Filtri__Checkbox"
                              {...getItemProps({
                                item,
                                index,
                                checked: selectedItems.includes(item),
                              })}
                              id={item.nome}
                              value={item.nome}
                              onChange={event => {
                                let newSelectedItems = selectedItems

                                if (event.target.checked) {
                                  newSelectedItems = [...selectedItems, item]
                                } else {
                                  newSelectedItems = selectedItems.filter(
                                    i => i.nome !== item.nome
                                  )
                                }

                                this.setState(
                                  {
                                    selectedAutori: newSelectedItems,
                                  },
                                  () => this.filtraListaOpere()
                                )
                              }}
                            />
                            <span />
                            {item.nome}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </DownshiftCheckbox>

              {/* Luogo */}

              <label className="Mappe__Filtri__Label mt-1">
                <FormattedMessage id="mappe.luogo" />
              </label>

              <DownshiftCheckbox
                itemToString={item => (item ? item.nome.nome : '')}
              >
                {({
                  getToggleButtonProps,
                  selectedItems,
                  getItemProps,
                  isOpen,
                }) => (
                  <div className="custom-select-checkbox">
                    <button
                      {...getToggleButtonProps()}
                      className={`custom-select-button ${
                        isOpen ? 'open' : ''
                      } `}
                    >
                      {selectedItems.length > 0 && (
                        <span className="Mappe__Filtri__SelectedFilters">
                          {selectedItems.reduce(
                            (acc, next, index) => `${acc}${index > 0 ? ',' : ''}
                    ${next.nome}`,
                            ''
                          )}
                        </span>
                      )}

                      {selectedItems.length === 0 && (
                        <span>
                          <FormattedMessage id="mappe.filtra" />
                        </span>
                      )}
                    </button>
                    {!isOpen ? null : (
                      <div className={`item-list ${isOpen ? 'open' : ''} `}>
                        {this.state.luoghi.map((item, index) => (
                          <label
                            className="checkbox-label custom-select-label"
                            htmlFor={item.nome}
                            key={item.nome}
                          >
                            <input
                              type="checkbox"
                              className="Mappe__Filtri__Checkbox"
                              {...getItemProps({
                                item,
                                index,
                                checked: selectedItems.includes(item),
                              })}
                              id={item.nome}
                              value={item.nome}
                              onChange={event => {
                                let newSelectedItems = selectedItems

                                if (event.target.checked) {
                                  newSelectedItems = [...selectedItems, item]
                                } else {
                                  newSelectedItems = selectedItems.filter(
                                    i => i.nome !== item.nome
                                  )
                                }

                                this.setState(
                                  {
                                    selectedLuoghi: newSelectedItems,
                                  },
                                  () => this.filtraListaOpere()
                                )
                              }}
                            />
                            <span />
                            {item.nome}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </DownshiftCheckbox>

              {/* Periodo */}

              <label className="Mappe__Filtri__Label mt-1">
                <FormattedMessage id="mappe.periodo" />
              </label>

              <DownshiftCheckbox
                itemToString={item => (item ? item.nome.nome : '')}
              >
                {({
                  getToggleButtonProps,
                  selectedItems,
                  getItemProps,
                  isOpen,
                }) => (
                  <div className="custom-select-checkbox">
                    <button
                      {...getToggleButtonProps()}
                      className={`custom-select-button ${
                        isOpen ? 'open' : ''
                      } `}
                    >
                      {selectedItems.length > 0 && (
                        <span className="Mappe__Filtri__SelectedFilters">
                          {selectedItems.reduce(
                            (acc, next, index) => `${acc}${index > 0 ? ',' : ''}
                    ${next.nome}`,
                            ''
                          )}
                        </span>
                      )}

                      {selectedItems.length === 0 && (
                        <span>
                          <FormattedMessage id="mappe.filtra" />
                        </span>
                      )}
                    </button>
                    {!isOpen ? null : (
                      <div className={`item-list ${isOpen ? 'open' : ''} `}>
                        {this.state.periodi.map((item, index) => (
                          <label
                            className="checkbox-label custom-select-label"
                            htmlFor={item.nome}
                            key={item.nome}
                          >
                            <input
                              type="checkbox"
                              className="Mappe__Filtri__Checkbox"
                              {...getItemProps({
                                item,
                                index,
                                checked: selectedItems.includes(item),
                              })}
                              id={item.nome}
                              value={item.nome}
                              onChange={event => {
                                let newSelectedItems = selectedItems

                                if (event.target.checked) {
                                  newSelectedItems = [...selectedItems, item]
                                } else {
                                  newSelectedItems = selectedItems.filter(
                                    i => i.nome !== item.nome
                                  )
                                }

                                this.setState(
                                  {
                                    selectedPeriodi: newSelectedItems,
                                  },
                                  () => this.filtraListaOpere()
                                )
                              }}
                            />
                            <span />
                            {item.nome}
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </DownshiftCheckbox>
            </div>
          </div>
        </div>
      </div>
    )

    if (typeof window !== 'undefined') {
      return <HashRouter>{content}</HashRouter>
    }

    return content
  }
}

export default withRouter(MappePage)

export const query = graphql`
  fragment FluidImage on DatoCmsAsset {
    url
    fluid(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }) {
      base64
      aspectRatio
      src
      srcSet
      sizes
    }
  }

  fragment Galleria on DatoCmsGalleriaImmagini {
    id
    model {
      apiKey
    }
    immagini {
      didascalia
      immagine {
        fixed(height: 400) {
          base64
          aspectRatio
          width
          height
          src
          srcSet
        }
        ...FluidImage
      }
    }
  }

  query PuntiMappa($locale: String!) {
    datoCmsPaginaGuida(locale: { eq: $locale }) {
      testoIntroduttivo
    }

    allDatoCmsPuntiSullaMappa(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          nome
          locale
          tipologiaOpera {
            nomeDellaTipologia
          }
          autore {
            nome
          }
          periodo {
            nome
          }
          luogo {
            nome
          }
          date
          indirizzo
          breveDescrizioneSchedaDescrittiva
          coordinate {
            latitude
            longitude
          }
          dettaglio {
            ... on DatoCmsTesto {
              id
              testo
              model {
                apiKey
              }
            }
            ...Galleria
          }
          immagineAssociata {
            id
            url
            resolutions {
              base64
              aspectRatio
              width
              height
              src
              srcSet
            }
          }
        }
      }
    }
    autori: allDatoCmsArchitettoIngegnere(
      sort: { fields: [position], order: ASC }
    ) {
      edges {
        node {
          locale
          nome
        }
      }
    }
    tipologieOpera: allDatoCmsTipologiaOpera(
      sort: { fields: [position], order: ASC }
    ) {
      edges {
        node {
          locale
          nomeDellaTipologia
        }
      }
    }
    luoghi: allDatoCmsLuogo(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          locale
          nome
        }
      }
    }
    periodi: allDatoCmsPeriodo(sort: { fields: [position], order: ASC }) {
      edges {
        node {
          locale
          nome
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/mappe.js